import React from 'react'
import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MegaMenu } from './MegaMenu'
import { useIntl } from 'react-intl'
import PermissionsGate from '../../../../app/pages/permissionsGate/PermissionsGate'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      <MenuItem title='แดชบอร์ด' to='/dashboard' />

      <PermissionsGate pageName="intent" scopes={['view']}>
        <MenuItem title='กลุ่มข้อความ' to='/intents' />
      </PermissionsGate>

      <PermissionsGate pageName="chat" scopes={['view']}>
        <MenuItem title='ประวัติการแชท' to='/apps/chat' />
      </PermissionsGate>

      <PermissionsGate pageName="fallback" scopes={['view']}>
        <MenuItem title='False Message' to='/false-message' />
      </PermissionsGate>

      {/* Report */}
      <MenuInnerWithSub
        title='รายงาน'
        to='/report'
        hasArrow={true}
        menuPlacement='bottom-start'
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        <MenuItem to='/report/1' title='รายงานปริมาณการใช้งาน' hasBullet={true} />
        <MenuItem to='/report/2' title='รายงานการใช้งาน' hasBullet={true} />
        <MenuItem to='/report/3' title='รายงานสถิติคำถาม / คำตอบ' hasBullet={true} />
        <MenuItem to='/report/3' title='รายงาน False Message' hasBullet={true} />
      </MenuInnerWithSub>

      {/* Setting */}
      <PermissionsGate pageName="setting" scopes={['view']}>
        <MenuInnerWithSub
          title='ตั้งค่า'
          to='/setting'
          hasArrow={true}
          menuPlacement='bottom-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/setting/users' title='ผู้ใช้งาน' hasBullet={true} />

          <PermissionsGate pageName="role" scopes={['view']}>
            <MenuItem to='/setting/role_&_permission' title='สิทธิ์แะการเข้าถึงระบบ' hasBullet={true} />
          </PermissionsGate>

          <MenuItem to='/setting/chatbox' title='กล่องแชท' hasBullet={true} />
          <MenuItem to='/setting/system' title='ข้อมูลระบบ' hasBullet={true} />
          <MenuItem to='/setting/chat-plugin' title='Chat Plugin' hasBullet={true} />
        </MenuInnerWithSub>
      </PermissionsGate>

      <MenuItem title='แบบสำรวจ' to='/poll' />

    </>
  )
}
